<template>
  <div class="c-app flex-row align-items-center">
    <CContainer style="display: flex; justify-content: center" class="p-0">
      <div class="container-box center">
        <div class="text-left">
          <div class="card-custom-web">
            <br />
            <CRow class="ml-2">
              <span
                v-if="student.profileImagePath == ''"
                class="custom-header-profile"
              >
                <img
                  width="50px"
                  height="50px"
                  src="../../assets/img/icon/userprofile2.svg"
                />
              </span>

              <span v-else class="custom-header-profile">
                <img
                  :src="photoURL"
                  width="50px"
                  height="50px"
                  style="border-radius: 30px"
                />
              </span>

              <div class="ml-2">
                <span class="custom-user-title" style="margin-bottom: 5px">
                  {{ student.studentName }}
                </span>
                <input
                  class="subject-selected"
                  v-model="SubjectName"
                  style="background-color: transparent; border: 0px solid"
                  disabled
                />
              </div>
              <span
                class="custom-sub-grade"
                style="color: #007cef; margin-top: 0px"
                > {{ student.gradeName }} </span
              >
            </CRow>

            <div class="list-grade">
              <CRow>
                <CCol sm="12">
                  <h3
                    style="color: #000; text-align: left"
                    class="custom-user-grade d-flex"
                  >
                    Willing to wait for
                    <CInput type="text" v-model="numberofweek" class="ml-2" block/>
                    <label class="ml-2">weeks</label>
                   
                  </h3>
                  <CButton type="button" @click="GoToSummary()" color="success" size="md" block>Submit</CButton>
                </CCol>
              </CRow>
            </div>
          </div>
        </div>
      </div>
      <MainlayoutBottom></MainlayoutBottom>
    </CContainer>

    <div style="clear: both"></div>
    <div class="header-top">Language</div>
    <div class="header-left">
      <img src="../../assets/img/icon/VectorLeft.svg" @click="GoBack()" />
    </div>
    <div class="header-right">
      <span @click="GoHomePage()"><CIcon name="cil-home"/></span>
      <br />
      
    </div>
    <div style="clear: both"></div>
  </div>
</template>
    
    <script>
import Vue from "vue";
import _ from "lodash";
Vue.use(require("vue-moment"));
import vSelect from "vue-select";
Vue.component("v-select", vSelect);

import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";
import MainlayoutBottom from "../../containers/TheBottomCustom.vue";

export default {
  data: function () {
    return {
      user: {},
      //subject: {},
      student: {},
      language: [],
      StudentId: this.$route.query.studentId,
      GradeId: this.$route.query.gradeId,
      SubjectId: this.$route.query.subjectId,
      SubjectName: this.$route.query.subjectName,

      teachers: [],
      tutorProfile: {},
      ShowResume: false,
      SelectedTeacher: "",
      photoURL: "",
      photoURLteacher: "",
      numberofweek: 1,
    };
  },
  components: {
    MainlayoutBottom,
  },
  async mounted() {
    let isAuth = await this.UserAuth();

    if (isAuth) {
      this.Busy = false;
      this.GetInfoUser();
      this.GetTeacherName();
    } else {
      this.GoToLogin();
    }
  },
  methods: {
    GoHomePage() {
      this.$router.push("FTClassType");
    },
    GetInfoUser() {
      return this.$API
        .get(this.$LoginUserDetailWebs, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.user = response.data;
            this.GetStudent(this.$route.query.studentId);
            //this.GetSubject(this.$route.query.subjectid);
            this.GetLanguage();
          }
        });
    },

    GetStudent() {
      this.$API
        .get(
          this.$StudentProfile + "?studentId=" + this.$route.query.studentId,
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.student = response.data;
            this.photoURL =
              "https://pickiddo.com" + this.student.profileImagePath;
            //this.studentid = this.student.id;
            console.log("student", this.student);
          }
        });
    },

    GetTeacherName() {
      this.$API
        .get(
          this.$GetListTeacherSubjectGrade +
            "?subjectId=" +
            this.$route.query.subjectId +
            "&gradeId=" +
            this.$route.query.gradeId,
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.teachers = response.data;
          }
        });
    },

    GetLanguage() {
      this.$API
        .get(this.$Languages, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.language = response.data;
          }
        });
    },

    GoBack() {
      this.$router.back();
    },
    OpenResume(Id) {
      this.teacherId = Id;

      this.$API
        .get(this.$ProfileTeacher + "?userId=" + this.teacherId, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.tutorProfile = response.data;
            this.photoURLteacher = this.tutorProfile.picturePath;
            //this.getPic(this.tutorProfile.profileImage);
          }
        });
      this.ShowResume = true;
    },

    GoToSummary(id, duration) {
      this.$router.push("/FindTutor/FTSummaryGroup?studentId=" +
        this.$route.query.studentId +
        "&gradeId=" +
        this.$route.query.gradeId +
        "&subjectId=" +
        this.$route.query.subjectId +
        "&subjectName=" +
        this.$route.query.subjectName +
        "&languageId=" +
        this.$route.query.languageId +
        "&language=" +
        this.$route.query.language +
        "&teacher=" +
        this.$route.query.teacher +
        "&durationWeek=" +
        this.numberofweek
      );
    },
    

    // ApplyFilter: function () {
    //   var arr = _.orderBy(this.subject, ["subjectName"], ["asc"]);
    //   if (_.isEmpty(arr) == false) {
    //     const result = _.filter(arr, ({ subjectName }) =>
    //       _.some([
    //         _.includes(!subjectName || subjectName.toLowerCase(), [
    //           this.SearchQuery.toLowerCase(),
    //         ]),
    //       ])
    //     );
    //     this.FilterSubject = result;
    //   }
    // },
  },
};
</script>
    
    <style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");

input[type="text"] {
  border-bottom: 2px solid #dbdbdb;
  background: none;
  border-top: none;
  border-left: none;
  border-right: none;
  width: 90%;
}
input[type="checkbox"] {
  opacity: 0;
}
input ::placeholder {
  color: #e0e0e0;
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #e0e0e0;
}
.c-app {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
}
.custom-bg-color {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
  /* Clickable/Light */

  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  margin: 0px 20px;
  display: flex;
  justify-content: center;
}
body {
  font-family: "Montserrat", sans-serif;
}
.card-custom-web {
  max-width: 700px;
  left: 0px;
  margin-top: 129px;
  height: 100vh;

  /* Off white */

  background: #f9f9f9;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.08);
  border-radius: 32px 0px 0px 0px;
  color: #000;
}

.subject-selected {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  /* identical to box height */

  /* #000A2C */

  color: #000a2c;
}
</style>